import React from 'react'
import { ProgressBar } from 'primereact/progressbar'
import { RECONNECTION_CONFIG } from '../config/reconnection.config'

/**
 * Component for reconnection progress state
 */
const ReconnectionProgress = ({
  displayName,
  attempt,
  timeLeft,
  isReconnecting,
  status = 'connecting',
}) => {
  const getStatusMessage = () => {
    switch (status) {
      case 'connecting':
        return `Intentando conectar a ${displayName}... (Intento ${attempt}/${RECONNECTION_CONFIG.MAX_ATTEMPTS})`
      case 'waiting':
        return `Esperando antes del siguiente intento...`
      default:
        return `Preparando reconexión a ${displayName}...`
    }
  }

  const getProgressValue = () => {
    return (
      ((attempt - 1) / RECONNECTION_CONFIG.MAX_ATTEMPTS) * 100 +
      ((RECONNECTION_CONFIG.COUNTDOWN_SECONDS - timeLeft) / RECONNECTION_CONFIG.COUNTDOWN_SECONDS) *
        (100 / RECONNECTION_CONFIG.MAX_ATTEMPTS)
    )
  }

  return (
    <div
      className="reconnection-progress"
      role="progressbar"
      aria-live="polite"
      aria-label={RECONNECTION_CONFIG.ARIA_LABELS.PROGRESS}
      aria-valuenow={getProgressValue()}
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <i className="pi pi-spin pi-spinner loading-icon" aria-hidden="true" />
      <h3>Reconectando...</h3>
      <p>{getStatusMessage()}</p>

      {attempt < RECONNECTION_CONFIG.MAX_ATTEMPTS && (
        <p className="next-attempt">
          Próximo intento en: <strong>{timeLeft} segundos</strong>
        </p>
      )}

      <ProgressBar
        value={getProgressValue()}
        showValue={false}
        className="reconnection-progress-bar"
        aria-label={`Progreso: ${Math.round(getProgressValue())}%`}
      />

      <div className="attempt-info">
        Intento {attempt} de {RECONNECTION_CONFIG.MAX_ATTEMPTS}
      </div>
    </div>
  )
}

export default ReconnectionProgress
